import { supportsLocale } from '@sbx/prec-shared-utils';
import { SuggestionsResponse } from '@/data/autocomplete/SuggestionsResponse';
import {
  getOurSelectionEndpoint,
  getPopularSearchesEndpoint,
  getSuggestionsEndpoint,
} from '../utils/constants/apiEndpoints';
import { api } from '../utils/api';

/**
 * @param {string} searchText
 * @returns {Object}
 */
export async function fetchSearchResults(searchText, searchByLocationEnabled) {
  const searchParams = new URLSearchParams({ text: searchText });
  const url = getSuggestionsEndpoint(searchParams, searchByLocationEnabled);
  const jsonResponse = await api.get(url);
  return SuggestionsResponse.map(jsonResponse);
}

export async function getRedirectMappings(brand, locale) {
  if (!supportsLocale(brand, locale)) throw new Error(`Context not supported: ${ brand }, ${ locale }`);

  const jsonResponse = await api.get(getOurSelectionEndpoint({ brand, locale }));

  return jsonResponse;
}

export async function getPopularSearches(brand, locale) {
  if (!supportsLocale(brand, locale)) throw new Error(`Context not supported: ${ brand }, ${ locale }`);

  const jsonResponse = await api.get(getPopularSearchesEndpoint({ brand, locale }));
  return jsonResponse;
}
